import { render, staticRenderFns } from "./ModelHeader.vue?vue&type=template&id=054d06f5&scoped=true&"
import script from "./ModelHeader.vue?vue&type=script&lang=js&"
export * from "./ModelHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModelHeader.vue?vue&type=style&index=0&id=054d06f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d06f5",
  null
  
)

export default component.exports